import GlobalLandingPage from "./GlobalLandingPage";
export default GlobalLandingPage;
